export const GET_WIZARD = "GET_WIZARD";
export const REST_STATE_WIZARD = "REST_STATE_WIZARD";
